export default {
  navigation: {
    next: "Avanti",
    back: "Indietro",
    surveyNavigation: "Navigazione del sondaggio",
    workspace: {
      home: "Home",
      example: "Esempio"
    }
  }
}
